import Typography from '@mui/material/Typography';
import Stack from '@mui/system/Stack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AuthData } from '../../../context/auth';
import {
	EndorsementData,
	withEndorsementContext,
} from '../../../context/EndorsementProvider';
import { capitalize } from '../../../util/util';
import { StyledSectionContainer } from '../../common';
import DisplayCard from '../../DisplayCard';

interface Props {
	authData: AuthData;
	endorsementData: EndorsementData;
}

/**
 * The overview page for an endorsement
 */
const Overview = (props: Props) => {
	const { t } = useTranslation();
	const { endorsementData, authData } = props;
	const { endorsementUpdateObj, productConfig } = endorsementData;

	if (!endorsementUpdateObj) {
		return null;
	}
	const endorsementConfig = productConfig.policyConfiguration.endorsements.find(
		(e) => e.name === endorsementUpdateObj.endorsementName,
	);
	const endorsementName = endorsementConfig?.displayName;

	const renderDetailCard = (title: string, data: string) => {
		return <DisplayCard title={title} value={data} />;
	};

	return (
		<StyledSectionContainer>
			<Stack spacing={2}>
				<Typography id='endorsement_id' variant='h3' gutterBottom>
					{`${t('endorsement.singular.upper')} ${endorsementUpdateObj.locator}`}
				</Typography>
				<Stack spacing={2} direction='row'>
					{renderDetailCard(
						`${t('endorsement.singular.upper')} Name`,
						endorsementName,
					)}
					{renderDetailCard(
						'Created',
						authData.getFormattedDate(
							endorsementUpdateObj?.createdTimestamp?.toString(),
						),
					)}
					{renderDetailCard(
						'Effective Date',
						authData.getFormattedDate(
							endorsementUpdateObj?.startTimestamp?.toString(),
						),
					)}
					{endorsementUpdateObj.newPolicyEndTimestamp &&
						renderDetailCard(
							'New Policy End Date',
							authData.getFormattedDate(
								endorsementUpdateObj?.newPolicyEndTimestamp?.toString(),
							),
						)}
					{renderDetailCard(
						'Last Updated',
						authData.getFormattedDate(
							endorsementUpdateObj?.updatedTimestamp?.toString(),
						),
					)}
					{renderDetailCard('State', capitalize(endorsementUpdateObj.state))}
				</Stack>
			</Stack>
		</StyledSectionContainer>
	);
};

export default withEndorsementContext<Props>(Overview);
